<div class="mine-form-container">
  <h2 mat-dialog-title>
    {{ data ? 'Edit Mine' : 'Create New Mine' }}
  </h2>

  <form *ngIf="mineForm" [formGroup]="mineForm" (submit)="submit()" autocomplete="off">
    <div class="grid grid-cols-2 gap-1">
      <div class="flex flex-col w-full">
        <div class="form-field-label">
          Name
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput [formControl]="mineForm.controls['name']" />
          <mat-error *ngIf="mineForm.controls['name'].hasError('required')">
            Input is required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col w-full">
        <div class="form-field-label">
          Radius (miles)
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput type="number" [formControl]="mineForm.controls['radius']" />
          <mat-error *ngIf="mineForm.controls['radius'].hasError('required')">
            Input is required
          </mat-error>
          <mat-error *ngIf="mineForm.controls['radius'].hasError('max')">
            Radius cannot be more than 10
          </mat-error>
          <mat-error *ngIf="mineForm.controls['radius'].hasError('min')">
            Radius cannot be less than 0
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col w-full">
        <div class="form-field-label">
          Latitude
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput type="number" [formControl]="mineForm.controls['lat']" />
          <mat-error *ngIf="mineForm.controls['lat'].hasError('required')">
            Input is required
          </mat-error>
          <mat-error
            *ngIf="mineForm.controls['lat'].hasError('latitude') && !mineForm.controls['lat'].hasError('required')"
          >
            Latitude value should be between -90 and 90
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col w-full">
        <div class="form-field-label">
          Longitude
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <input matInput type="number" [formControl]="mineForm.controls['lng']" />
          <mat-error *ngIf="mineForm.controls['lng'].hasError('required')">
            Input is required
          </mat-error>
          <mat-error
            *ngIf="mineForm.controls['lng'].hasError('longitude') && !mineForm.controls['lng'].hasError('required')"
          >
            Longitude value should be between -180 and 180
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-span-2" id="map-mine"></div>

      <div class="col-span-2">
        <div class="mine-direction-location-heading">
          <h3 class="sub-form-heading">Mine Direction Location</h3>
          <mat-slide-toggle [formControl]="mineForm.controls['showMineDirectionLocation']"></mat-slide-toggle>
        </div>
        <div class="mine-direction-location-help">
          Use where the entrance to the facility is. This location is provided to drivers for their use in getting
          directions from 3rd party applications.
        </div>
      </div>

      <div
        class="col-span-2"
        id="map-mine-direction-location"
        [hidden]="!mineForm.controls['showMineDirectionLocation'].value"
      ></div>

      <div *ngIf="mineForm.controls['showMineDirectionLocation'].value" class="flex flex-col w-full">
        <div class="form-field-label">
          Longitude
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            placeholder="Latitude"
            type="number"
            [formControl]="mineForm.controls['mineDirectionLocationLat']"
          />
          <mat-error *ngIf="mineForm.controls['mineDirectionLocationLat'].hasError('required')">
            Input is required
          </mat-error>
          <mat-error
            *ngIf="
              mineForm.controls['mineDirectionLocationLat'].hasError('latitude') &&
              !mineForm.controls['mineDirectionLocationLat'].hasError('required')
            "
          >
            Latitude value should be between -90 and 90
          </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="mineForm.controls['showMineDirectionLocation'].value" class="flex flex-col w-full">
        <div class="form-field-label">
          Longitude
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <input
            matInput
            placeholder="Longitude"
            type="number"
            [formControl]="mineForm.controls['mineDirectionLocationLng']"
          />
          <mat-error *ngIf="mineForm.controls['mineDirectionLocationLng'].hasError('required')">
            Input is required
          </mat-error>
          <mat-error
            *ngIf="
              mineForm.controls['mineDirectionLocationLng'].hasError('longitude') &&
              !mineForm.controls['mineDirectionLocationLng'].hasError('required')
            "
          >
            Longitude value should be between -180 and 180
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col w-full col-span-2">
        <div class="form-field-label">
          Directions
        </div>
        <mat-form-field appearance="outline" class="w-full">
          <textarea matInput formControlName="siteDirections"></textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="flex flex-row border border-gray-400 rounded-md p-1 mb-3">
      <input
        id="file-upload"
        class="upload-button cursor-pointer flex-1"
        [disabled]="uploadingPOAttachment$$.asObservable() | async"
        (change)="onFileChange($event)"
        type="file"
        accept="application/pdf, image/*"
      />
      <label for="file-upload">
        <span class="material-icons cursor-pointer">cloud_upload</span>
        <span *ngIf="!(uploadingPOAttachment$$.asObservable() | async)" class="cursor-pointer">Upload Attachments</span>
        <span *ngIf="uploadingPOAttachment$$.asObservable() | async">Uploading...</span>
      </label>
    </div>
    <mat-grid-list
      *ngIf="(uploadedFiles$$ | async) && (uploadedFiles$$ | async).length > 0"
      cols="2"
      rowHeight="3:2"
      gutterSize="8px"
    >
      <mat-grid-tile *ngFor="let file of uploadedFiles$$ | async">
        <div class="flex flex-row w-full h-full border rounded-md border-gray-400">
          <div
            class="self-stretch flex flex-col justify-center rounded-l-md border-r-2 border-gray-400 hover:bg-red-500 cursor-pointer"
            [matTooltip]="'Delete'"
            (click)="deleteAttachment(file.id, data.id)"
          >
            <mat-icon class="material-icons">close</mat-icon>
          </div>
          <div class="w-full p-1 flex flex-row justify-center items-center">
            <img
              [src]="file.url"
              *ngIf="isImage(file.fileName); else noPreview"
              (click)="openInWindow(file.url)"
              class="cursor-pointer"
            />
            <ng-template #noPreview>
              <div class="preview-placeholder" (click)="openInWindow(file.url)" class="cursor-pointer">
                <h3>{{ file.fileName }}</h3>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-grid-tile>
    </mat-grid-list>

    <div class="actions" matDialogActions fxLayout="row" fxLayoutAlign="flex-end">
      <button mat-flat-button color="primary" mat-dialog-close color="accent">Cancel</button>
      <button *ngIf="canEdit" mat-flat-button color="primary" type="submit" [disabled]="submitting">
        {{ submitting ? 'Submitting...' : ' Submit' }}
      </button>
    </div>
  </form>
</div>
